<template>
  <div class="form-select" :class="[$attrs.class]" :tabindex="tabindex">
    <label v-if="$attrs.label?.length">
      <span
        class="form-select__label-wrapper"
        :class="{ 'form-select__label-wrapper--invalid': errorMessage.length }"
      >
        <span class="label-title">{{ $attrs.label }}</span>
        <span v-if="$attrs['label-optional']" class="label-subtitle">{{
          $attrs['label-optional']
        }}</span>
      </span>
    </label>
    <wa-select
      v-model="localValue"
      v-bind="$attrs"
      label=""
      :placeholder="$attrs.placeholder"
      @keydown.tab="preventTabPropagation"
      @change="handleChange"
    >
      <!-- eslint-disable-next-line vue/no-v-for-template-key -->
      <template v-for="(option, index) in options" :key="index">
        <wa-divider v-if="option.dividerTop"></wa-divider>
        <wa-option :value="option.value" :disabled="option.disabled">{{ option.text }}</wa-option>
      </template>
    </wa-select>
    <span v-if="errorMessage.length" class="form-select__error-message">{{ errorMessage }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import '@awesome.me/webawesome/dist/components/select/select.js'
import '@awesome.me/webawesome/dist/components/option/option.js'

defineOptions({
  inheritAttrs: false
})

const emit = defineEmits(['update:modelValue', 'onSelect'])
const props = defineProps({
  modelValue: {
    type: [String, Array],
    default: ''
  },
  error: {
    type: String,
    default: ''
  },
  options: {
    type: Array,
    default: () => []
  },
  tabindex: {
    type: String,
    default: '0'
  }
})

const errorMessage = computed(() => props.error)
const localValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

function handleChange(event) {
  emit('onSelect', event.target.value)
}

function preventTabPropagation(event) {
  if (event.key === 'Tab') {
    event.stopPropagation()
  }
}
</script>
<style src="@/components/Form/FormSelect/FormSelect.css" scoped />
